const getOrCreateLegendList = (chart, legendContainer) => {
	let listContainer = legendContainer.querySelector('ul');

	if (!listContainer) {
		listContainer = document.createElement('ul');
		legendContainer.append(listContainer);
	}

	return listContainer;
};

const htmlLegendPlugin = {
	id: 'htmlLegend',
	afterUpdate(chart, args, options) {
		const ul = getOrCreateLegendList(chart, options.container);

		while (ul.firstChild) {
			ul.firstChild.remove();
		}

		const items = chart.options.plugins.legend.labels.generateLabels(chart);

		for (const [index, item] of items.entries()) {
			const li = document.createElement('li');

			li.addEventListener('mouseover', () => {
				chart.setActiveElements([
					{
						datasetIndex: index,
						index: 0,
					},
				]);
				chart.render();
			});

			li.addEventListener('mouseout', () => {
				chart.setActiveElements([]);
				chart.render();
			});

			const boxSpan = document.createElement('span');
			boxSpan.style.background = item.fillStyle;

			const textContainer = document.createElement('p');

			const text = document.createTextNode(item.text);
			textContainer.append(text);

			li.append(boxSpan);
			li.append(textContainer);
			ul.append(li);
		}
	},
};

export default htmlLegendPlugin;
